'use client';
import { Button } from '@/components/ui/button';
import Link from 'next/link';

export function CtaSection() {
  return (
    <section
      className="bg-primary text-primary-foreground"
    >
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold font-headline">Ready to Boost Your Child's Brainpower?</h2>
        <p className="mt-4 text-lg text-primary-foreground/80 max-w-2xl mx-auto">
          Join thousands of happy families and give your child the gift of future-ready skills. Book a free demo class today and see the difference for yourself.
        </p>
        <div className="mt-8">
          <Button asChild size="lg" variant="accent" className="rounded-full text-lg py-6 px-10">
            <Link href="/book-demo">Book Your Free Demo Now</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
